// extracted by mini-css-extract-plugin
export var animationContainer = "_j7-0";
export var asteriskIcon = "_j7-8";
export var conversationLeftSection = "_j7-4";
export var conversationListItem = "_j7-3";
export var conversationMiddleSection = "_j7-5";
export var conversationRightSection = "_j7-6";
export var detailsContent = "_j7-1";
export var listContainer = "_j7-7";
export var modalContent = "_j7-2";